import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle } from 'lucide-react';
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show after 5 seconds
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Hide after 13 seconds (8 seconds visible)
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 13000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-274">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 z-50 max-w-sm bg-surface border border-border rounded-xl shadow-2xl p-4 pr-10" data-id="element-275">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-muted hover:text-white transition-colors" data-id="element-276">
            <X size={16} data-id="element-277" />
          </button>

          <div className="flex items-start gap-3" data-id="element-278">
            <div className="mt-1" data-id="element-279">
              <CheckCircle className="text-brand" size={20} data-id="element-280" />
            </div>
            <div data-id="element-281">
              <div className="text-xs text-brand font-bold mb-1 uppercase tracking-wider" data-id="element-282">
                Compra verificada
              </div>
              <p className="text-sm text-gray-300 leading-tight" data-id="element-283">
                <span className="font-bold text-white" data-id="element-284">Valentina R.</span> de
                Ciudad de México compró{' '}
                <span className="font-medium text-white" data-id="element-285">
                  MegaPack IA + AI OS 🤖
                </span>{' '}
                hace 2 minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}